import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconMp348(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="mp3">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23C1 21.3431 2.34315 20 4 20H35C36.6569 20 38 21.3431 38 23V33C38 34.6569 36.6569 36 35 36H4C2.34315 36 1 34.6569 1 33V23ZM4 22C3.44772 22 3 22.4477 3 23V33C3 33.5523 3.44772 34 4 34H35C35.5523 34 36 33.5523 36 33V23C36 22.4477 35.5523 22 35 22H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 5C9 2.23858 11.2386 0 14 0H32C32.2589 0 32.5078 0.100428 32.6941 0.280156L46.6941 13.7802C46.8896 13.9686 47 14.2285 47 14.5V43C47 45.7614 44.7614 48 42 48H14C11.2386 48 9 45.7614 9 43V35H11V43C11 44.6569 12.3431 46 14 46H42C43.6569 46 45 44.6569 45 43V15.5H34C32.3431 15.5 31 14.1569 31 12.5V2H14C12.3431 2 11 3.34315 11 5V21H9V5ZM33 3.35347L43.5223 13.5H34C33.4477 13.5 33 13.0523 33 12.5V3.35347Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M14.5521 32L14.5401 26.96L12.0681 31.112H11.1921L8.73211 27.068V32H6.90811V23.6H8.51611L11.6601 28.82L14.7561 23.6H16.3521L16.3761 32H14.5521ZM22.005 23.6C22.749 23.6 23.393 23.724 23.937 23.972C24.489 24.22 24.913 24.572 25.209 25.028C25.505 25.484 25.653 26.024 25.653 26.648C25.653 27.264 25.505 27.804 25.209 28.268C24.913 28.724 24.489 29.076 23.937 29.324C23.393 29.564 22.749 29.684 22.005 29.684H20.313V32H18.369V23.6H22.005ZM21.897 28.1C22.481 28.1 22.925 27.976 23.229 27.728C23.533 27.472 23.685 27.112 23.685 26.648C23.685 26.176 23.533 25.816 23.229 25.568C22.925 25.312 22.481 25.184 21.897 25.184H20.313V28.1H21.897ZM30.3783 27.02C31.1143 27.14 31.6783 27.416 32.0703 27.848C32.4623 28.272 32.6583 28.8 32.6583 29.432C32.6583 29.92 32.5303 30.372 32.2743 30.788C32.0183 31.196 31.6263 31.524 31.0983 31.772C30.5783 32.02 29.9383 32.144 29.1783 32.144C28.5863 32.144 28.0023 32.068 27.4263 31.916C26.8583 31.756 26.3743 31.532 25.9743 31.244L26.7303 29.756C27.0503 29.996 27.4183 30.184 27.8343 30.32C28.2583 30.448 28.6903 30.512 29.1303 30.512C29.6183 30.512 30.0023 30.42 30.2823 30.236C30.5623 30.044 30.7023 29.776 30.7023 29.432C30.7023 28.744 30.1783 28.4 29.1303 28.4H28.2423V27.116L29.9703 25.16H26.3943V23.6H32.2743V24.86L30.3783 27.02Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
